<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <OthersPurchaseInputPivotComponent ref='refOthersPurchaseInputPivotComponent' v-if='selectedIndex < tabLastIndex' @refresh-input-vendor-list="refreshInputVendorList"
    pType='S0106' materialType='S0408,S0409' :company="company" :selected-vendor="selectedVendor"/>
    <InventoryReceipt ref='refInventoryReceipt' v-else-if='selectedIndex === tabLastIndex' :materialType='외주품'/>

  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import OthersPurchaseInputPivotComponent from './OthersPurchaseInputPivotComponent'
// import PurchaseComponent from '../base-data/PurchaseComponent.vue'
import InventoryReceipt from '../InventoryMag/InventoryReceipt.vue'
import AppLib from '../../share/AppLib'

export default {
  name: 'OutsourcedGoodsPivotTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabLastIndex: null,
      tabs: [
        {
          title: '자재구매내역'
        }
      ],
      company: null,
      thisYear: null,
      selectedMonth: null,
      selectedVendor: null,
      외주품: ConstDef.외주품
    }
  },
  components: {
    DxTabPanel,
    OthersPurchaseInputPivotComponent,
    InventoryReceipt
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    // this.init()
    this.refreshInputVendorList(`${AppLib.getThisYear()}-${AppLib.getThisMonth()}`)
  },
  mounted () {
    // this.$refs.refOthersPurchaseInputPivotComponent.refreshDataGridFromParent('ALL')
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()
    },
    onSelectedVendor () {
      console.log(this.selectedIndex)
      console.log(this.tabLastIndex)
      if (this.selectedIndex < this.tabLastIndex) {
        this.selectedVendor = this.tabs[this.selectedIndex].입고업체
        this.company = this.tabs[this.selectedIndex].거래처명
        this.$refs.refOthersPurchaseInputPivotComponent.refreshDataGridFromParent(this.selectedVendor)
      }
    },
    refreshInputVendorList (date) {
      console.log(`${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`)
      const param = {
        자재유형: `${ConstDef.외주품},${ConstDef.외주직납품}`
      }
      this.$_sp.runNoEncodeFindProc('spFindAllVendorListOfPurchaseType', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          this.tabs.push({ 거래처명: '외주품 입고내역' })
          this.tabLastIndex = (this.tabs.length - 1)
          this.company = this.tabs[this.selectedIndex].거래처명
          this.selectedVendor = this.tabs[this.selectedIndex].입고업체
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
